// Utilidad para verificar que GA4 esté funcionando correctamente
// Puedes llamar esta función desde la consola del navegador para diagnosticar

export function verifyGA4() {
  const win = window as any;
  const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

  console.log("🔍 Verificando configuración de GA4...");
  console.log("━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━");

  // 1. Verificar ID de medición
  console.log("1️⃣ ID de medición:", GA_MEASUREMENT_ID || "❌ NO DEFINIDO");

  // 2. Verificar dataLayer
  if (win.dataLayer) {
    console.log("2️⃣ dataLayer:", "✅ Existe");
    console.log("   - Longitud:", win.dataLayer.length);
    console.log("   - Contenido:", win.dataLayer);
  } else {
    console.log("2️⃣ dataLayer:", "❌ NO EXISTE");
  }

  // 3. Verificar gtag
  if (win.gtag && typeof win.gtag === 'function') {
    console.log("3️⃣ gtag:", "✅ Disponible");
  } else {
    console.log("3️⃣ gtag:", "❌ NO DISPONIBLE");
  }

  // 4. Verificar script de GA4
  const script = document.querySelector('script[src*="www.googletagmanager.com/gtag/js"]');
  if (script) {
    console.log("4️⃣ Script de GA4:", "✅ Cargado");
    console.log("   - URL:", (script as HTMLScriptElement).src);
  } else {
    console.log("4️⃣ Script de GA4:", "❌ NO ENCONTRADO");
  }

  // 5. Verificar eventos en dataLayer
  if (win.dataLayer && win.dataLayer.length > 0) {
    console.log("5️⃣ Eventos en dataLayer:", win.dataLayer.length);
    win.dataLayer.forEach((event: any, index: number) => {
      console.log(`   Evento ${index + 1}:`, event);
    });
  } else {
    console.log("5️⃣ Eventos en dataLayer:", "⚠️ No hay eventos");
  }

  // 6. Intentar enviar un evento de prueba
  if (win.gtag && GA_MEASUREMENT_ID) {
    console.log("6️⃣ Enviando evento de prueba...");
    try {
      win.gtag("event", "test_event", {
        event_category: "test",
        event_label: "verification",
        value: 1
      });
      console.log("   ✅ Evento de prueba enviado");
    } catch (error) {
      console.log("   ❌ Error al enviar evento:", error);
    }
  }

  console.log("━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━");
  console.log("💡 Para verificar en tiempo real:");
  console.log("   1. Ve a https://analytics.google.com");
  console.log("   2. Selecciona tu propiedad GA4");
  console.log("   3. Ve a 'Informes' > 'Tiempo real'");
  console.log("   4. Deberías ver tu visita en los últimos 30 minutos");
}

// Exponer en window para uso desde consola
if (typeof window !== 'undefined') {
  (window as any).verifyGA4 = verifyGA4;
}

